module.exports = __webpack_public_path__ + "img/couples_04_V.8a8b873c.webp";